<template>
  <div>
    <AppProgress :current="currentStep" :total="components.length" />
    <transition :name="transition" mode="out-in">
      <component :is="component" />
    </transition>
  </div>
</template>

<script>
  import AppProgress from '@/components/AppProgress';

  export default {
    name: 'MultiStepForm',
    components: { AppProgress },
    props: {
      components: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    data() {
      return {
        transition: 'slide-left',
      };
    },
    watch: {
      currentStep(to, from) {
        this.transition = from < to ? 'slide-left' : 'slide-right';
      },
    },
    computed: {
      component() {
        return this.components[this.currentStep - 1];
      },
      currentStep() {
        return this.$store.state.signup.currentStep;
      },
    },
  };
</script>

<style scoped>
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active {
    transition: transform 250ms linear;
  }

  .slide-left-enter,
  .slide-right-leave-to {
    transform: translateX(44rem);
  }

  .slide-right-enter,
  .slide-left-leave-to {
    transform: translateX(-44rem);
  }
</style>
